import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { getCsaStaticJsUrl, getCscEntityPrefix } from '../config/Config';
import { StateContext } from '../GlobalStateStore';
import { getEnvConfigByKey } from '../config/EnvConfig';

interface CSATagProps {
  applicationName: string;
}

const CSATag: React.FC<CSATagProps> = ({ applicationName }: CSATagProps) => {
  const localSessionid = window.localStorage.getItem(
    'PerformancePortalService_sessionID'
  );

  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const { requesterUserID, requesterOwner, requesterUsername, isTm } =
    inspireOptions.data;

  useEffect(() => {
    // Following snippet is copied from CSA onboarding page:
    // https://info.analytics.a2z.com/#/docs/data_collection/csa/onboard
    /*eslint-disable */
    // @ts-ignore
    function n(n, t) {
      let r = i(n);
      // @ts-ignore
      return (t && (r = r('instance', t)), r);
    }
    // @ts-ignore
    const r: any[] = [];
    let c = 0;
    // @ts-ignore
    var i = function (t) {
      return function () {
        const n = c++;
        return (
          r.push([
            t,
            [].slice.call(arguments, 0),
            n,
            {
              time: Date.now(),
            },
          ]),
          i(n)
        );
      };
    };
    // @ts-ignore
    n._s = r;
    window.csa = n;

    window.csa('Config', {
      Application: applicationName,
      'Events.SushiEndpoint': getEnvConfigByKey('sushiUrl'),
      'Events.Namespace': 'csa',
    });
    /* eslint-enable */
  }, []);

  useEffect(() => {
    if (
      !requesterUserID ||
      !requesterOwner ||
      !requesterUsername ||
      !localSessionid
    )
      return;

    window.csa('Events')('setEntity', {
      session: {
        id: localSessionid,
      },
      user: {
        id: requesterUserID,
        cscEntityPrefix: getCscEntityPrefix(),
        isTM: `${isTm}`, // Nexus Schema requires a String
        requestOwner: requesterOwner,
        username: requesterUsername,
      },
    });

    const myEvents = window.csa('Events', {
      producerId: 'customerservice_ati',
    });

    myEvents('log', {
      schemaId: 'CSAPEAnalytics.UserSessions.1',
      sessionId: localSessionid,
      cscEntityPrefix: getCscEntityPrefix(),
      userId: requesterUserID,
      isTM: `${isTm}`,
      application: applicationName,
      pageServer: window.location.host,
    });
  }, [localSessionid, inspireOptions.data]);

  return (
    <Helmet>
      <script src={getCsaStaticJsUrl()} />
    </Helmet>
  );
};

export default CSATag;
